import { useState, useEffect } from 'react';
import { portalService } from '../services/portalService';
import { connectionManagementService } from '../../../services/connectionManagementService';
import { useRegion } from '../../../shared/contexts/RegionContext';
import type { UseCase } from '@amzn/aws-gcr-content-connection-management-client';

interface UseApplicationsReturn {
  applications: UseCase[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useApplications = (): UseApplicationsReturn => {
  const [applications, setApplications] = useState<UseCase[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { currentRegion } = useRegion();

  const fetchApplications = async () => {
    try {
      setLoading(true);
      setError(null);
      connectionManagementService.setRegion(currentRegion);
      const data = await portalService.getAllApplications();
      setApplications(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load applications');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, [currentRegion]);

  return { applications, loading, error, refetch: fetchApplications };
};
